import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#transaction #company_id	{ width: 10rem;		}
			#transaction #id			{ width: 6rem; text-align: right;	}
			#transaction #user_id		{ width: 10rem;		}
			#transaction #date_time		{ width: 10rem;		}
			#transaction #product_id	{ width: 32rem; 	}
			#transaction #lot_id		{ width: 10rem;		}
			#transaction #quantity		{ width: 10rem; text-align: right;	}
			#transaction #value			{ width: 10rem; text-align: right;	}
			#transaction #source_type	{ width: 8rem;		}
			#transaction #target_type	{ width: 8rem;		}
			#transaction #source		{ width: 24rem;	}
			#transaction #target		{ width: 24rem;	}
			#transaction #movement_kind	{ width: 20rem; }
		</style>
		<form id="transaction" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="lots">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da transação">Transação
					<input id="id" type="text" disabled>
				</label>
				<label title="Usuário autor da transação">Usuário
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Data e hora da transação">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Classificação operacional (opcional)">Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label title="Excluir esta transação">Desabilitar
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb">
				<label title="Produto movimentado">Produto<sup>*</sup>
					<input id="product_id" type="text" list="products" required>
				</label>
				<label title="Lote movimentado">Lote<sup>*</sup>
					<input id="lot_id" type="text" list="lots" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de origem">Origem Tipo<sup>*</sup>
					<input id="source_type" type="text" list="transaction_types" required>
				</label>
				<label title="Origem da movimentação">Origem<sup>*</sup>
					<input id="source" type="text" required>
				</label>
				<label title="Quantidade movimentada">Qtde<sup>*</sup>
					<input id="quantity" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Tipo de destino">Destino Tipo<sup>*</sup>
					<input id="target_type" type="text" list="transaction_types" required>
				</label>
				<label title="Destino da movimentação">Destino<sup>*</sup>
					<input id="target" type="text" required>
				</label>
				<label title="Preço de custo total do lote movimentado">Valor<sup>*</sup>
					<input id="value" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#transaction',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			formset.loadList('#users', 'users');
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#product_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#lot_id' }, types: [types.pubsub(), types.datalist(), types.observer('product_id'), types.obs_load_options('lots', { labels: ['lot_number', 'id'], sep: ' · ', key: 'company_id', range: 1 })] },
		{ properties: { selector: '#user_id' }, types: [types.datalist()] },
		{ properties: { selector: '#date_time' }, types: [types.datetime()] },
		{ properties: { selector: '#movement_kind' }, types: [types.opt_movement_kind(), types.datalist()] },
		{ properties: { selector: '#source_type' }, types: [types.opt_transaction_type(), types.datalist()] },
		{ properties: { selector: '#target_type' }, types: [types.opt_transaction_type(), types.datalist()] },
		{ properties: { selector: '#source' }, types: [types.json()] },
		{ properties: { selector: '#target' }, types: [types.json()] },
		{ properties: { selector: '#quantity' }, types: [types.number(0, 2)]},
		{ properties: { selector: '#value' }, types: [types.number(2)] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]

};

